export default __webpack_public_path__ + "static/media/1-star.0cf5315a.png";